import router from "@/router";
import { useIdentityStore } from "@/stores/identity";

// * Gate the very first navigation on boot rehydration: the store is empty (no in-memory access
//   token) until rehydrate() exchanges the HttpOnly refresh cookie. Without this, the initial
//   guard runs before rehydration resolves and bounces users with a valid session to /login. The
//   flag is module-level so the await happens only once; rehydrate() itself single-flights via
//   refreshAccessToken(), so concurrent calls share the same in-flight promise.
let rehydrated = false;

export default {
  install(): void {
    const IdentityStore = useIdentityStore();
    router.beforeEach(async (to) => {
      if (!rehydrated) {
        rehydrated = true;
        await IdentityStore.rehydrate();
      }
      const hasAuthentication = to.meta.requiresAuth ? IdentityStore.isAuthenticated : true;
      const hasRoleBasedAccess = IdentityStore.hasPermission({
        requiredRoles: to.meta.requiredRoles,
        requiredGroups: to.meta.requiredGroups,
      });
      if (!(hasAuthentication && hasRoleBasedAccess)) {
        IdentityStore.returnUrl = to.fullPath;
        return {
          name: "login",
        };
      }
    });
  },
};
